import { MainApi } from "./MainApi";

export class ProductApi {
  static baseUrl = `${MainApi.urlPrefix}/user/product`;

  static getTheLatestProduct = () => () =>
    MainApi.api.get(`${ProductApi.baseUrl}/the-latest?display_position=USER_WEB`);

  static getProductImages = (productIdx: number) => () =>
    MainApi.api.get(`${ProductApi.baseUrl}/${productIdx}/image?display_position=USER_WEB`);
}
